//package
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Card, Col, Row } from "react-bootstrap";
import OtpInput from "react-otp-input";

// includes
import { api, common } from "includes";

export default function OtpVerification() {
  // const
  const navigate = useNavigate();

  // state
  const [count, setCount] = useState<number>(5);
  const [email, setEmail] = useState<any>("");
  const [resendTimer, setResendTimer] = useState<number>(59); // Timer for Resend OTP
  const [otp, setOtp] = useState<any>("");
  const [error, setError] = useState<any>(null);
  const [utils, setUtils] = useState<any>({
    formSubmit: false,
    tokenStatus: "success",
    pwdErr: null,
    redirecting: false,
  });

  // effect
  useEffect(() => {
    //common.tempDataRemove();
  }, []);

  useEffect(() => {
    if (utils.tokenStatus != "success" && count > 0 && !utils.redirecting) {
      const countdown = setInterval(() => {
        setCount((prevCount) => prevCount - 1);
      }, 1000);

      return () => {
        clearInterval(countdown);
      };
    } else if (
      utils.tokenStatus != "success" &&
      count === 0 &&
      !utils.redirecting
    ) {
      utilsState("redirecting", true);
      navigate("/login");
    }
  }, [utils.tokenStatus, count, utils.redirecting]);

  // resend OTP countdown
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [resendTimer]);

  const onSubmit = () => {
    if (otp.length < 6) {
      setError("Enter the code");
    } else {
      OtpVerification();
    }
  };
  // api
  const OtpVerification = () => {
    utilsState("formSubmit", true);
    let email: any = common.tempDataGet();
    let payload = {
      email,
      otp,
    };

    let data = {
      url: "app/auth/otp-verify",
      method: "POST",
      auth: "none",
      body: payload,
    };

    api.call(data, (res: any) => {
      if (res.status === 200) {
        if (res.data.code == "success") {
          common.tempDataSet(res.data?.data?.resetToken);
          utilsState("tokenStatus", "success");
          common.notify("S", res.data.message);
          navigate("/password/reset");
        } else {
          if (res.data.code == "token_expired") {
            utilsState("tokenStatus", "tokenExpired");
          } else if (res.data.code === "invalid_otp") {
            utilsState("otpError", "Invalid OTP. Please try again.");
            common.notify("E", "Invalid OTP. Please try again.");
          }
        }
      } else {
        common.notify("E", "Cannot Connect to Server, Please try Again!");
      }

      utilsState("formSubmit", false);
    });
  };

  // Resend OTP api call
  const resendOtp = () => {
    const email: string | null = common.tempDataGet(); // Retrieve stored email

    if (!email) {
      common.notify("E", "No email found. Please try again.");
      return;
    }

    const data = {
      url: "/app/auth/forgot-password",
      method: "POST",
      auth: "none",
      body: {
        email,
      },
    };

    api.call(data, (res: any) => {
      if (res.status === 200) {
        if (res.data.code === "success") {
          setEmail(res?.data?.email);
          common.notify("S", res?.data?.message || "OTP resent successfully!");
          setResendTimer(59); // Reset resend timer
        } else {
          common.notify("E", res.data.message || "Failed to resend OTP.");
        }
      } else {
        common.notify("E", "Cannot connect to server. Please try again!");
      }
    });
  };
  const utilsState = (label: any, value: any) => {
    setUtils((prev: any) => ({
      ...prev,
      [label]: value,
    }));
  };
  //render
  return (
    <Row className="justify-content-center">
      <Col xxl={4} lg={5}>
        <Card>
          <Card.Header className="py-4 text-center bg-primary">
            <Link to="/">
              <span>
                <img src={common.loadImg("logo.png")} alt="logo" height="30" />
              </span>
            </Link>
          </Card.Header>
          <Card.Body className="p-4">
            {utils.tokenStatus == "tokenExpired" && (
              <div className="text-center w-75 mx-auto">
                <h4 className={`text-dark-50 text-center pb-0 fw-bold`}>
                  Token Expired
                </h4>
                <div className="logout-icon mx-auto mb-2">
                  <i className="ri-error-warning-line auto-card-icon"></i>
                </div>
                <h4 className={`text-dark-50 text-center pb-0 fw-bold`}>
                  Reset Token has Expired! Try Again!!
                </h4>{" "}
                <p className="text-muted mb-2">
                  Redirecting to Login in 5 seconds...
                </p>{" "}
                <div className="countdown-container">
                  <h2 className="my-2">{count}</h2>
                </div>
              </div>
            )}
            {utils.tokenStatus == "success" && (
              <>
                <div className="text-center w-75 m-auto">
                  <h4 className={`text-dark-50 text-center pb-0 fw-bold`}>
                    Reset Password
                  </h4>
                  <p className="text-muted mb-4">Reset your password here.</p>
                </div>
                <form onSubmit={() => { }}>
                  <Form.Group className={"mb-3"}>
                    <Form.Label>Verification Code</Form.Label>
                    <OtpInput
                      value={otp}
                      onChange={(value) => {
                        setError(null);
                        setOtp(value);
                      }}
                      numInputs={6}
                      inputType="tel"
                      containerStyle="otp-input"
                      inputStyle={{
                        width: "44px",
                        height: "48px",
                        color: "#000",
                        fontWeight: "400",
                        fontSize: "22px",
                        caretColor: "blue",
                      }}
                      renderSeparator={<span>-</span>}
                      renderInput={(props) => <input {...props} />}
                    />
                    <p className="err-txt">{error}</p>
                  </Form.Group>
                  <div className="mb-3 text-center">
                    {resendTimer > 0 ? (
                      <p>
                        Resend OTP in 0:
                        {resendTimer < 10 ? `0${resendTimer}` : resendTimer}
                      </p>
                    ) : (
                      <Button
                        variant="link"
                        className="p-0"
                        onClick={resendOtp}
                      >
                        Resend OTP
                      </Button>
                    )}
                  </div>
                  <div className="mb-3 text-center">
                    <Button
                      variant="primary"
                      type="button"
                      onClick={onSubmit}
                      disabled={utils.formSubmit ? true : false}
                    >
                      {utils.formSubmit && (
                        <span
                          role="status"
                          className="spinner-border text-white  spinner-border-sm me-2"
                        ></span>
                      )}
                      {utils.formSubmit ? "Processing.." : "Submit"}
                    </Button>
                  </div>
                </form>
              </>
            )}
          </Card.Body>
        </Card>
        <Row className="mt-3">
          <Col className="text-center">
            <p className="text-muted bg-body">
              Want to Go Back?
              <Link
                to="/login"
                className="text-muted ms-1 link-offset-3 text-decoration-underline"
              >
                <b>Sign In</b>
              </Link>
            </p>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
